import Swiper from './components/swiper';

const swiper = new Swiper('.quotes-swiper', {
    centeredSlides: true,
    watchOverflow: true,
    direction: 'horizontal', 
    spaceBetween: 0,
    centeredSlides: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    autoplay: {
        delay: 5000,
      },
});


const singleSwipers = document.querySelectorAll(".single-post-swiper");
const singleSwipersNext = document.querySelectorAll(".single-post-container .swiper-button-next");
const singleSwipersPrev = document.querySelectorAll(".single-post-container .swiper-button-prev");
const singleSwipersPagination = document.querySelectorAll(".single-post-container .swiper-pagination");

for( let i = 0; i < singleSwipers.length; i++ ) {
    
    singleSwipers[i].classList.add('single-post-swiper-' + i);

    const nextButton = singleSwipersNext[i];
    const prevButton = singleSwipersPrev[i];
    const pagination = singleSwipersPagination[i];

    const singlePostSwiper = new Swiper('.single-post-swiper-' + i, {
        direction: 'horizontal', 
        spaceBetween: 0,
        loop: true,
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        pagination: {
            el: pagination,
            clickable: true
        },
    });
  
}

const tripleSwipers = document.querySelectorAll(".triple-post-swiper");
const tripleSwipersNext = document.querySelectorAll(".triple-post-container .swiper-button-next");
const tripleSwipersPrev = document.querySelectorAll(".triple-post-container .swiper-button-prev");
const tripleSwipersPagination = document.querySelectorAll(".triple-post-container .swiper-pagination");

for( let i = 0; i < tripleSwipers.length; i++ ) {
    
    tripleSwipers[i].classList.add('triple-post-swiper-' + i);

    const nextButton = tripleSwipersNext[i];
    const prevButton = tripleSwipersPrev[i];
    const pagination = tripleSwipersPagination[i];

    const triplePostSwiper = new Swiper('.triple-post-swiper-' + i, {
        direction: 'horizontal', 
        spaceBetween: 0,
        slidesPerView: 1,
        loop: true,
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        pagination: {
            el: pagination,
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 32,
            },
            900: {
                slidesPerView: 3,
                spaceBetween: 32,
            }
        }
    });
  
}

const doubleSwipers = document.querySelectorAll(".double-post-swiper");
const doubleSwipersNext = document.querySelectorAll(".double-post-container .swiper-button-next");
const doubleSwipersPrev = document.querySelectorAll(".double-post-container .swiper-button-prev");
const doubleSwipersPagination = document.querySelectorAll(".double-post-container .swiper-pagination");

for( let i = 0; i < doubleSwipers.length; i++ ) {
    
    doubleSwipers[i].classList.add('double-post-swiper-' + i);

    const nextButton = doubleSwipersNext[i];
    // const prevButton = doubleSwipersPrev[i];
    const pagination = doubleSwipersPagination[i];

    const doublePostSwiper = new Swiper('.double-post-swiper-' + i, {
        direction: 'horizontal', 
        spaceBetween: 0,
        slidesPerView: 1,
        loop: true,
        navigation: {
            nextEl: nextButton,
        },
        pagination: {
            el: pagination,
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 32,
            }
        }
    });
  
}